<template>
  <b-container fluid class="position-relative d-flex align-items-center justify-content-center" style="min-height: calc(100vh - 150px)">
    <h2>Пожалуйста, обратитесь в техническую поддержку!</h2>
  </b-container>
</template>

<script>
  export default {
    name: "UserWithoutRights"
  }
</script>

<style scoped>
  h2 {
    margin-bottom: 0;
    color: #37474F;
    font-size: 25px;
    font-weight: 500;
    line-height: 28px;
  }
</style>
